import { Box, Skeleton } from '@mantine/core'

import classes from './OpportunityCard.module.scss'

export function OpportunityCardSkeleton() {
  return (
    <Box data-testid="opportunity-card-skeleton">
      <Skeleton height={140} className={classes.BannerSkeleton} />
      <Skeleton height={24} width="75%" className={classes.TitleSkeleton} />
      <Skeleton height={20} width="60%" />
    </Box>
  )
}
